// extracted by mini-css-extract-plugin
export default {"time_box":"Steam_time_box__IKi2z","time_label":"Steam_time_label__BmbNn","chart_wrapper":"Steam_chart_wrapper__X9dkC"};